import { BaseError, type BaseErrorOptions } from "@sunrise/error";

export class RefreshTokenFailedError extends BaseError {
  constructor(message: string, options?: BaseErrorOptions) {
    super("RefreshTokenFailedError", message, options);
  }
}
